import { api } from "../BaseConfig";

export const locumSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getlocumCards: builder.query({
      query: (data) => ({
        url: `/${data.acc_type}/locum-card`,
        method: "GET",
      }),
    }),
    getlocumDivisionSummary: builder.query({
      query: (data) => ({
        url: `/${data.acc_type}/locum-division-summary`,
        method: "GET",
      }),
    }),
    getlocumAnnualSummary: builder.query({
      query: (data) => ({
        url: `/${data.acc_type}/locum-annual-summary`,
        method: "GET",
      }),
    }),
    getlocumgraph: builder.query({
      query: (data) => {
        
        return {
          url: `/${data.acc_type}/locum-graph`,
          method: "GET",
          params: data.filters,
        };
      },
    }),
  }),
});

export const {
  useGetlocumCardsQuery,
  useGetlocumDivisionSummaryQuery,
  useGetlocumAnnualSummaryQuery,
  useGetlocumgraphQuery,
} = locumSlice;
